export default {"src":"/_next/static/media/generic-thumbnail-img.6a4b8ccd.svg","height":92,"width":66,"blurWidth":0,"blurHeight":0};